import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class ClosureService {
  constructor(private http: HttpClientService) {}
  representativeCache: Observable<any>;
  bankAccountsCache: Observable<any>;

  getClosure(closure_id: string) {
    return this.http
      .get("/api/closures/" + closure_id, null)
      .pipe(tap((_) => console.log("ClosureService.getAllClosures: Ok.")));
  }

  getAllClosures(filter) {
    filter = this.removeNullProperties(filter);
    const options = { params: filter };
    return this.http.get("/api/closures", options).pipe(tap((_) => console.log("ClosureService.getAllClosures: Ok.")));
  }

  public create(closure: Closure): Observable<any> {
    return this.http
      .post("/api/closures", closure, { responseType: "blob" as "json" })
      .pipe(tap((_) => console.log("ClosureService.createClosure: Ok.")));
  }

  addDationPayment(accident_id: number, params: Params) {
    return this.http
      .post("/api/closures/" + accident_id + "/add_dation_payment", params)
      .pipe(tap((_) => console.log("ClosureService.addDationPayment: Ok.")));
  }

  public flux(id: number | string, action: string, usuario_id: number | string, options?: any): Observable<any> {
    const params = {
      flux_action: action,
      options: options || {},
      usuario_id: usuario_id,
    };
    return this.http
      .post("/api/closures/" + id + "/flux_action", params)
      .pipe(tap((_) => console.log("ClosureService.flux: Ok.")));
  }

  public bulkAction(ids: string[], action: string, usuario_id: number | string, options?: any): Observable<any> {
    const params = {
      ids,
      flux_action: action,
      options: options || {},
      usuario_id: usuario_id,
    };
    return this.http
      .post("/api/closures/bulk_action", params)
      .pipe(tap((_) => console.log("ClosureService.bulkAction: Ok.")));
  }

  saveDationDetails(closure_id: number, params: SaleDetails) {
    return this.http
      .post("/api/closures/" + closure_id + "/dation_details", params)
      .pipe(tap((_) => console.log("ClosureService.saveDationDetails: Ok.")));
  }

  public updateDetails(id: number | string, params): Observable<any> {
    return this.http
      .put("/api/closures/" + id + "/update_details", params)
      .pipe(tap((_) => console.log("ClosureService.updateDetails: Ok")));
  }

  downloadReport(from, to) {
    const params = {
      from,
      to,
    };
    return this.http
      .post("/api/closures/download_report", params)
      .pipe(tap((_) => console.log("ClosureService.downloadReport: Ok.")));
  }

  removeNullProperties(obj) {
    for (let prop in obj) {
      if (obj[prop] === null) {
        delete obj[prop];
      }
    }
    return obj;
  }
}

interface Closure {
  contract_start_date: string;
  id: number;
  insurer: string;
  policy_end_date: string;
  policy_start_date: string;
  stp_account: string;
  closure_type: string;
  accumulated_debt: any[];
  params?: {};
}

interface Params {
  compensation_amount?: number;
  compensation_date?: string;
  final_sale_price_amount?: number;
  final_sale_price_date?: string;
  earned_premium_amount?: number;
  earned_premium_date?: string;
  no_compensation?: boolean;
  user?: string;
  user_name?: string;
  comment?: string;
}

interface SaleDetails {
  appraisal: number;
  sale_point: string;
  sale_point_name: string;
  entry_date: string;
  sale_price: number;
  comment?: string;
}
